<div>
  <evrideo-job-settings [vm]="vm"></evrideo-job-settings>

  <ngx-smart-modal
    #chooseSegment
    identifier="chooseSegmentModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered'"
  >
    <evrideo-choose-segment></evrideo-choose-segment>
  </ngx-smart-modal>
</div>
